import { SortDescriptor } from '@progress/kendo-data-query';
import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { MessagesRealTimeData } from 'src/generated/signalR/messages-real-time-data';
import { SamwinMessageInfoRemoteDto } from 'src/generated/signalR/samwin-message-info-remote-dto';
import { Attachment } from 'src/generated/swagger';
import { ActionErrorDescription } from '../../notification/notification-toastr/types/actionErrorDescription.decorator';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

export class MessageListChanged {
   public static readonly type = '[Samwin MessageList] message list changed';

   constructor(public updatedMailList: SamwinMessageInfoRemoteDto[]) {}
}

// TODO: change how messages are updated
export class MessagesChanged {
   public static readonly type = '[Samwin MessageList] messages changed';

   constructor(public messages: MessagesRealTimeData) {}
}

export class SearchValueChanged {
   public static readonly type = '[Samwin MessageList] search value changed';

   constructor(public searchValue: string) {}
}

export class MessageFilterChanged {
   public static readonly type = '[Samwin MessageList] message filter changed';

   constructor(public groupName: string, public skillId: number) {}
}

export class MessageListChangeCustomSorting {
   public static readonly type = '[Samwin MessageList] message list custom sorting changed';

   constructor(public customSorting: SortDescriptor[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.MAIL_WAITLIST)
export class GetMessageContent {
   public static readonly type = '[Samwin MessageList] get message content';

   constructor(public messageId: string) {}
}

export class UpdateMessageDroppableStatus {
   public static readonly type = '[Samwin MessageList] update dropable state';

   constructor(public canBeDropped: boolean) {}
}

export class UpdateMessageDraggedStatus {
   public static readonly type = '[Samwin MessageList] update dragging state';

   constructor(public isDragged: boolean) {}
}

export class MessagesSearchStateChanged {
   public static readonly type = '[Samwin MessageList] messages search state changed';

   constructor(public searchState: boolean) {}
}
@LongRunningAction(LongRunningContextCategoryTyp.MAIL_WAITLIST)
@ActionErrorDescription({
   titleTranslationKey: 'brick.brick_definitions.mail_wait_list.error_handling.loading_failed.title',
   messageTranslationKey: 'brick.brick_definitions.mail_wait_list.error_handling.loading_failed.message',
})
export class GetSearchedMessages {
   public static readonly type = '[Samwin MessageList] get searched messages';

   constructor(public searchText: string, public folder: string, public skill: number) {}
}

export class UpdateSearchValues {
   public static readonly type = '[Samwin MessageList] update searched messages';

   constructor() {}
}

export class OpenMessage {
   public static readonly type = '[Samwin MessageList] open message';

   constructor(public callId: number, public messageId: string) {}
}

export class CloseMessage {
   public static readonly type = '[Samwin MessageList] close message';

   constructor(public callId: number, public messageId: string, public folderId: number) {}
}

export class ReassignMessage {
   public static readonly type = '[Samwin MessageList] reassign message';

   constructor(public callId: number, public messageId: string) {}
}

export class MoveMessage {
   public static readonly type = '[Samwin MessageList] move message';

   constructor(public messageId: string, public newFolderId: number, public newSkillId: number) {}
}

export class MarkMessageActive {
   public static readonly type = '[Samwin MessageList] mark message active';

   constructor(public callId: number, public hasFocus: boolean) {}
}

export class MarkMessageUndone {
   public static readonly type = '[Samwin MessageList] mark message undone';

   constructor(public callId: number, public messageId: string) {}
}

export class ReQueueMessage {
   public static readonly type = '[Samwin MessageList] requeue message';

   constructor(public callId: number, public queueId: number, public messageId: string) {}
}

export class ParkMessageOnSkill {
   public static readonly type = '[Samwin MessageList] park message on skill';

   constructor(public callId: number, public queueId: number, public messageId: string) {}
}

export class ParkMessageOnAgent {
   public static readonly type = '[Samwin MessageList] park message on agent';

   constructor(public callId: number, public messageId: string) {}
}

export class GetAttachment {
   public static readonly type = '[Samwin MessageList] get attachment';

   constructor(public attachment: Attachment, public messageId: string) {}
}

export class GetAttachments {
   public static readonly type = '[Samwin MessageList] get attachments';

   constructor(public attachments: Attachment[], public messageId: string) {}
}

export class RemoveFromMessages {
   public static readonly type = '[Samwin MessageList] remove message from state to immediatly update the waitlist';

   constructor(public messageId: string) {}
}

export class ChangeMessageFolder {
   public static readonly type = '[Samwin MessageList] change email folder';

   constructor(public messageId: string, public folderSqlValue: number) {}
}

export class MessageListEntrySelected {
   public static readonly type = '[Samwin MessageList] entry selected';

   constructor(public messageId: string) {}
}

export class MessageListSelectNextEntry {
   public static readonly type = '[Samwin MessageList] Select next entry';

   constructor(public direction: 'up' | 'down', public step = 1) {}
}

export class SetMessageListSkillFilter {
   public static readonly type = '[Samwin MessageList] Set Message List Skill Filter';

   constructor(public skillIds: number[]) {}
}
